




































import Vue, { PropType } from "vue";
import ProductSlide from "@/components/ProductItem.vue";
import { mapGetters } from "vuex";
import { MagentoProduct } from "@/lib/MagentoTypes";
import { BreakpointListener } from "@/lib/tailwindBreakpoints"; // tailwindBreakpoints,
import ButtonIcon from "./ButtonIcon.vue";

export default Vue.extend({
  name: "ProductSlider",
  props: {
    title: {
      type: String,
      default: () => ""
    },
    products: {
      type: Array as PropType<MagentoProduct[]>,
      default: () => []
    },
    breakPoints: {
      type: Object as PropType<{ [key in keyof BreakpointListener]?: number }>,
      default: () => ({
        default: 2,
        xs: 2,
        sm: 2,
        md: 3,
        lg: 4,
        xl: 4,
        xl2: 4
      })
    }
  },
  components: {
    ProductSlide,
    ButtonIcon
  },
  data() {
    return {
      offset: 0,
      productsToShow: 0,  
    };
  },
  watch: {
    activeMql: {
      immediate: true,
      handler(val: keyof BreakpointListener) {
        if (this.onBreakpointChangeHandlers[val]) {
          this.onBreakpointChangeHandlers[val]!();
        }
      }
    }
  },
  methods:{
    validateProduct(product:MagentoProduct):boolean {
      const hasGalleryEntries = Array.isArray(product?.media_gallery_entries) && product?.media_gallery_entries.length;
//      const hasSublineZero = (product?.subline == 0 ? true : false);
//      return hasGalleryEntries && !hasSublineZero ? true : false;
      return hasGalleryEntries ? true : false;
    }
  },
  computed: {
    ...mapGetters({
      activeMql: "active"
    }),
    showButtons():boolean {
      return this.maxOffset > 0;
    },
    maxOffset(): number {
      const maxOffset = this.products.length - this.productsToShow;
      this.offset =
        this.offset > maxOffset && maxOffset >= 0 ? maxOffset : this.offset;
      return maxOffset;
    },
    productsStyle(): string {
      let removeProducts = 0;
      for(let i=0;i<this.products.length;i++){
        if(!this.validateProduct(this.products[i])){
          removeProducts++;
        }
      }
      return `--offset: ${this.offset}; --products-to-show: ${this.productsToShow - removeProducts}; --gap: 30px;`;      
//      return `--offset: ${this.offset}; --products-to-show: ${this.productsToShow};`;
    },
    onBreakpointChangeHandlers(): {
      [key in keyof BreakpointListener]: () => void;
    } {
      const breakpointTuples = Object.entries(this.breakPoints);
      const breakpointsWithHandlers = breakpointTuples.map(([key, value]) => [
        key,
        () => (this.productsToShow = value as number)
      ]);
      return Object.fromEntries(breakpointsWithHandlers);
    }
  }
});
